export interface Constraint {
  frame: number;
  endEffector: string;
  dx: number;
  dy: number;
  dz: number;
}

export const END_EFFECTOR_NAMES = [
  'pelvis',
  'left_ankle',
  'right_ankle',
  'head',
  'left_wrist',
  'right_wrist',
] as const;

export type EndEffectorName = (typeof END_EFFECTOR_NAMES)[number];

export const END_EFFECTOR_COLORS: Record<EndEffectorName, string> = {
  pelvis: '#ff6b6b',
  left_ankle: '#4ecdc4',
  right_ankle: '#45b7d1',
  head: '#f9ca24',
  left_wrist: '#a55eea',
  right_wrist: '#fd79a8',
};

/** Map from BVH joint names to end-effector names (case-insensitive matching) */
export function findEndEffectorBone(
  jointNames: string[],
  eeName: EndEffectorName,
): number {
  const lower = jointNames.map((n) => n.toLowerCase());
  const idx = lower.findIndex((n) => n === eeName || n === eeName.replace(/_/g, ''));
  if (idx !== -1) return idx;

  // Fallback: partial match
  const parts = eeName.split('_');
  return lower.findIndex((n) => parts.every((p) => n.includes(p)));
}
